import { useEffect, useRef, useState } from 'react';
export const useCompanySelection = ({ companies, onSelectCompany, onGoBack, initialCompanyId, }) => {
    const [selectedCompany, setSelectedCompany] = useState(initialCompanyId || companies[0]?.id || '');
    const previousCompaniesLength = useRef(companies.length);
    const selectedCompanyData = companies.find(company => company.id === selectedCompany);
    const hasSelection = Boolean(selectedCompany);
    const handleSelectCompany = () => {
        if (selectedCompany) {
            onSelectCompany(selectedCompany);
        }
    };
    const handleGoBack = () => {
        onGoBack();
    };
    const reset = () => {
        setSelectedCompany(initialCompanyId || companies[0]?.id || '');
    };
    useEffect(() => {
        if (companies.length > 0 && previousCompaniesLength.current === 0) {
            const validInitialCompany = initialCompanyId && companies.some(c => c.id === initialCompanyId);
            const companyToSelect = validInitialCompany ? initialCompanyId : companies[0].id;
            setSelectedCompany(companyToSelect);
        }
        previousCompaniesLength.current = companies.length;
    }, [companies, initialCompanyId]);
    useEffect(() => {
        if (companies.length > 0 && selectedCompany) {
            const isValidSelection = companies.some(company => company.id === selectedCompany);
            if (!isValidSelection) {
                setSelectedCompany(companies[0].id);
            }
        }
    }, [companies, selectedCompany]);
    return {
        selectedCompany,
        setSelectedCompany,
        hasSelection,
        selectedCompanyData,
        handleSelectCompany,
        handleGoBack,
        reset,
    };
};
